//Participant/Update/{AuthToken}/{ParticipantGuid}/{GroupGuid}/{ParticipantGroupGuid}/{LanguageID}/{LastName}/{FirstName}/{MiddleName}/{BioDOB}/{BioGender}/{BioRace}/{BioRace2}/{BioRace3}/{SpokenLanguageID}/{Email}/{StatusID}/{EducationLevelGuid}/{Medicaid}/	

import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from "react-redux";
import { Button, Grid, Typography, Box } from '@mui/material'
import { motion, AnimatePresence } from "framer-motion/dist/framer-motion"
import { selectParticipantDemographicsById } from '../../../reducers/admincenter_participantdemographics';
import { adminparticipantModify, selectAdminParticipantById } from '../../../reducers/admincenter_participants';
import ReportCriteriaGroupSelect from './ReportCriteriaGroupSelect';
import { selectContextEntities } from '../../../reducers/global_contexts';
import { selectAdminGroupsById } from '../../../reducers/admincenter_groups';
import { fetchParticipantMoves, participantmoveClear } from '../../../reducers/admincenter_participantmove';
import MoveDownIcon from '@mui/icons-material/MoveDown';
import { selectErrorMessagesByNegativeCode } from '../../../reducers/reference_errormessages';



const ParticipantMove = (props) => {
    const dispatch = useDispatch()

    const ParticipantGuid = props.Participant.ParticipantGuid
    const Participant = useSelector(state => selectAdminParticipantById(state, ParticipantGuid))

    const { user: currentUser } = useSelector((state) => state.auth);

    const Contexts = useSelector(state => selectContextEntities(state))
    const { participantMoveGroupGuid } = Contexts


    const ParticipantAdditionalInfo = useSelector(state => selectParticipantDemographicsById(state, Participant.ParticipantGuid))


    const Group_From = useSelector(state => selectAdminGroupsById(state, ParticipantAdditionalInfo.GroupGuid))
    const Group_To = useSelector(state => selectAdminGroupsById(state, participantMoveGroupGuid))

    const participantMoveStatus = useSelector(state => state.participantmoves.status)
    const participantMoveError = useSelector(state => state.participantmoves.error)
    const ErrorMessage = useSelector(state => selectErrorMessagesByNegativeCode(state, participantMoveError && participantMoveError.ErrorID))
    const [isError, setIsError] = useState(false)
    const [isSuccess, setIsSuccess] = useState(false)

    useEffect(() => {
        if (participantMoveStatus === "success") {


            setIsSuccess(true)

            setTimeout(() => {
                dispatch(adminparticipantModify({
                    ...Participant
                    , GroupGuid: Group_To.OrganizationId_Guid
                    , GroupName: Group_To.OrganizationName
                }))
                handleCancel()
            }, 3000)
        }
        else if (participantMoveStatus === "failed") {
            setIsError(true)
        }
    }, [participantMoveStatus])

    const SaveToDatabase = () => {
        dispatch(fetchParticipantMoves({
            ParticipantId_Guid: Participant.ParticipantGuid
            , ParticipantGroupGuid_To: participantMoveGroupGuid
            , authToken: currentUser.AuthToken
        }))

    }

    const handleCancel = () => {
        setIsError(false)
        dispatch(participantmoveClear())
        props.cancelButton()

    }




    return (
        <Grid container direction="row" alignItems="center" justifyContent="center" spacing={4}>
            <Grid item xs={12}>
                <Typography variant="h4" align="center">Move Participant</Typography>
            </Grid>
            <Grid item xs={12} md={6}>
                <ReportCriteriaGroupSelect SelectLocation="PARTICIPANT MOVE" />
            </Grid>
            <Grid item xs={12} md={6}>
                <Grid container direction="row" alignItems="center" justifyContent="center" spacing={1}>
                    <Grid item xs={12} md={8}>
                        <Typography variant="h6">Moving User: {Participant.UserName}</Typography>
                    </Grid>
                    <Grid item xs={12} md={8}>
                        <Grid container direction="row" alignItems="center" justifyContent="center" spacing={3}>
                            <Grid item xs={4} md={2} justifyContent="flex-end">
                                <MoveDownIcon fontSize="large" color="primary" />
                            </Grid>
                            <Grid item xs={8} md={10}>
                                <Grid container direction="row" alignItems="center" justifyContent="center" spacing={3}>
                                    <Grid item xs={12} md={12}>
                                        <Typography variant="body1">From: {Group_From && Group_From.OrganizationName}</Typography>
                                    </Grid>

                                    <Grid item xs={12} md={12}>
                                        <Typography variant="body1">To: {Group_To && Group_To.OrganizationName}</Typography>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>


            <Grid item xs={12} justifyContent="center">
                <Grid container direction="row" alignItems="center" justifyContent="center" spacing={2}>
                    <Grid item xs={3}>
                        <Box display="flex" justifyContent="center">
                            <Button fullWidth variant="contained" color="success"
                                disabled={!participantMoveGroupGuid}
                                onClick={() => { SaveToDatabase() }}>Move Participant</Button>
                        </Box>
                    </Grid>
                    <Grid item xs={3}>
                        <Box display="flex" justifyContent="center">
                            <Button fullWidth variant="contained" color="error" onClick={() => { handleCancel() }}>Cancel</Button>
                        </Box>
                    </Grid>
                </Grid>
            </Grid>


            {

                isError === true && (
                    <Grid item xs={12}>
                        <Box>
                            <Typography variant="h6" color="error" align="center">
                                {
                                    (ErrorMessage && ErrorMessage.length > 0 && ErrorMessage[0].MessageTypeContent)
                                    ||
                                    (participantMoveError && participantMoveError.ErrorMessage)
                                }
                            </Typography>
                        </Box>
                    </Grid>
                )
            }
            {

                isSuccess === true && (
                    <Grid item xs={12}>
                        <Box>
                            <Typography variant="h6" color="success.main" align="center">
                                Participant successfully moved!
                            </Typography>
                        </Box>
                    </Grid>
                )
            }
        </Grid>
    )


}
export default ParticipantMove
